import { PureComponent } from "react";
import { StyledStoriesSlickCarouselComponent } from "./stories-slick-carousel-component.scss";
import Slider from "react-slick";
import classnames from "classnames";

export default class StoriesSlickCarouselComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.updateDimensions = this.updateDimensions.bind(this);
    this.state = {
      windowWidth: 0,
      windowHeight: 0
    };
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  /**
   * Calculate & Update state of new dimensions
   */
  updateDimensions() {
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  }

  renderItems() {
    const { items, renderItem } = this.props;
    return items.map((item, index) => (
      <div key={index} className="carousel-item">
        {renderItem(item, index)}
      </div>
    ));
  }

  renderItemsWithCarousel(settings) {
    return (
      <Slider {...settings} ref={settings.onCarouselMounted}>
        {this.renderItems()}
      </Slider>
    );
  }

  // showing on mobile
  renderItemsWithoutCarousel(items, renderItem) {
    return <div className={"items-without-carousel"}>{items.map((item, index) => renderItem(item, index))}</div>;
  }

  render() {
    const { items, renderItem, minWidthForCarousel, ...settings } = this.props;
    const { windowWidth } = this.state;

    const showCarousel = !windowWidth || windowWidth > minWidthForCarousel;
    return (
      <StyledStoriesSlickCarouselComponent className={classnames("stories-slick-carousel")}>
        {showCarousel && this.renderItemsWithCarousel(settings)}
        {!showCarousel && this.renderItemsWithoutCarousel(items, renderItem)}
      </StyledStoriesSlickCarouselComponent>
    );
  }
}

StoriesSlickCarouselComponent.defaultProps = {
  dots: true,
  infinite: true,
  fade: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 8000,
  minWidthForCarousel: -1 // if width smaller than that - don't render carousel
};
